<template>
  <div class="weetContainer">
    <iframe id="weetPlayer" class="weetPlayer" type="text/html"
            :src="url" allowtransparency="true"
            allowfullscreen frameborder="0" height="100%">

    </iframe>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component(
    {
      name: 'ExternalWeetPlayer',
    })
export default class ExternalWeetPlayer extends Vue {

  @Prop()
  private url!: string;

}
</script>

<style scoped lang="scss">
@import "@/scss/shadows.scss";

.weetContainer {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  // min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  @extend .shadow1;

  .weetPlayer {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}

</style>
